var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 11.5303C10.7626 11.8232 11.2374 11.8232 11.5303 11.5303C11.8232 11.2374 11.8232 10.7626 11.5303 10.4697L10.4697 11.5303ZM3 2.25C2.58579 2.25 2.25 2.58579 2.25 3L2.25 9.75C2.25 10.1642 2.58579 10.5 3 10.5C3.41421 10.5 3.75 10.1642 3.75 9.75V3.75H9.75C10.1642 3.75 10.5 3.41421 10.5 3C10.5 2.58579 10.1642 2.25 9.75 2.25L3 2.25ZM11.5303 10.4697L3.53033 2.46967L2.46967 3.53033L10.4697 11.5303L11.5303 10.4697Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5303 12.4697C13.2374 12.1768 12.7626 12.1768 12.4697 12.4697C12.1768 12.7626 12.1768 13.2374 12.4697 13.5303L13.5303 12.4697ZM21 21.75C21.4142 21.75 21.75 21.4142 21.75 21L21.75 14.25C21.75 13.8358 21.4142 13.5 21 13.5C20.5858 13.5 20.25 13.8358 20.25 14.25L20.25 20.25L14.25 20.25C13.8358 20.25 13.5 20.5858 13.5 21C13.5 21.4142 13.8358 21.75 14.25 21.75L21 21.75ZM12.4697 13.5303L20.4697 21.5303L21.5303 20.4697L13.5303 12.4697L12.4697 13.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.1c0a9090ae7b523f4124f7bc3f5d2f87.svg";
export { ForwardRef as ReactComponent };